// extracted by mini-css-extract-plugin
export default {"card":"styles_card__oY-I6","header":"styles_header__4Eqq4","body":"styles_body__mq3hX","close":"styles_close__0IQOF","error":"styles_error__iq41n"};